<template>
  <div class="changestate">
    <ul  class="changestateul">
      <li v-for="(tab,index) in tabs" @click="toggle(index,tab.view)" :class="{active:active==index}">
        {{tab.type}}
      </li>
      <div class="clearfix"></div>
    </ul>
    <div class="clearfix"></div>
    <!--:is实现多个组件实现同一个挂载点-->
    <component :is="currentView" v-show="show"></component>
    <view-track v-show="!show"></view-track>
  </div>
</template>

<script>
  import ChangeStatefirst from './ChangeStatefirst'
  import ViewStatus from './ViewStatus'
  // import ViewTrack from './ViewTrack'
  export default {
    name: 'ChangeState',
    components: {
      ChangeStatefirst,
      ViewStatus,
    },
    data: function () {
      return {
        active: 0,
        currentView: 'ViewStatus',
        tabs: [
        {
            type: '手机找回密码',
            view: 'ViewStatus'
          },
          {
            type: '邮箱找回密码',
            view: 'ChangeStatefirst'
          }
        ],
        show: true
      }
    },
    methods: {
      toggle (i, v) {
        this.active = i
        this.currentView = v
        this.show=true
      },
      shows () {
        this.show=false
      }

    }
  }
</script>

<style lang="stylus" scoped>
  @import '~styles/varibles.styl'
  @import '~styles/mixins.styl'
  .changestate{
    position:relative;
    margin:0 auto;
    height:610px;
    background:#fff;
    border:10px solid #a9e0bf;
    padding-left:-20px;
    padding:24px;
    .erweima{
      position:absolute;
      top:15px;
      right:15px;
    }
    .changestateul{
      border-bottom:1px solid #dddddd;
    }
    .changestateul li{
      float:left;
      margin-right:30px;
      height:32px;
      font-size:16px;
      font-weight:bold;
      line-height:32px;
      cursor:pointer;
      text-align:center;
      border-radius:3px;
      &.active{
        color:$bgColor;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/findpwd/components/ChangeState.vue